import { type WidgetSettingsDefinition } from "@repo/api";
import { Option, Select, Text } from "@repo/skapa";
import { t } from "@repo/translation";
import {
  ElementsContainer,
  getParentTasksForContext,
  getSubTasksForContext,
  sortTaskTranslationKeys,
  translateTaskType,
  useSettings,
} from "@repo/ui";
import uniq from "lodash/uniq";

export const TaskSelectSettingsControl = ({
  settingDefinition,
  setting,
  setSetting,
}: {
  settingDefinition: WidgetSettingsDefinition;
  setting: Record<string, any>;
  setSetting: (newSetting: Record<string, object>) => void;
}) => {
  const { calendar, task_configuration, language } = useSettings();
  const value = setting[settingDefinition.id]
    ? [setting[settingDefinition.id]]
    : [];

  const parentType = value?.toString().split("|")?.[0];
  const subType = value?.toString().split("|")?.[1];

  const allParentTaskTypes = uniq([
    ...getParentTasksForContext(
      "CALENDAR",
      calendar,
      task_configuration?.task_types
    ),
    ...getParentTasksForContext(
      "PROJECT",
      calendar,
      task_configuration?.task_types
    ),
  ]);

  const sortedParentTaskTypes = sortTaskTranslationKeys(
    (key) =>
      translateTaskType(
        language,
        key,
        undefined,
        task_configuration?.task_types
      ),
    allParentTaskTypes
  );

  const sortedSubTaskTypes = sortTaskTranslationKeys(
    (key) =>
      translateTaskType(
        language,
        parentType,
        key,
        task_configuration?.task_types
      ),
    getSubTasksForContext(
      undefined,
      parentType,
      calendar,
      task_configuration?.task_types
    )
  );

  return (
    <ElementsContainer>
      <Text textStyle="Heading.XS">{settingDefinition.title}</Text>
      <Select
        id="calendar-task-type-select"
        label={t("label.task_type")}
        defaultValue={parentType}
        onChange={(e) => {
          setSetting({ ...setting, [settingDefinition.id]: e.target.value });
        }}
      >
        {sortedParentTaskTypes.map((val) => {
          return <Option key={val.key} value={val.key} name={val.label} />;
        })}
      </Select>
      <Select
        id="calendar-task-sub-type-select"
        label={t("label.subtype")}
        defaultValue={subType}
        onChange={(e) => {
          setSetting({
            ...setting,
            [settingDefinition.id]: `${parentType}|${e.target.value}`,
          });
        }}
      >
        {parentType !== undefined
          ? sortedSubTaskTypes.map((val) => (
              <Option key={val.key} value={val.key} name={val.label} />
            ))
          : null}
      </Select>
    </ElementsContainer>
  );
};
